
// Check for client updates
export default function ({ app: { $logger }, store, route }) {
  // force a page refresh if the latest version doesn't match
  if (store.get('kintell/latestVersion') !== process.env.VERSION) {
    window.location.href = route.fullPath
    $logger.info('Invalid Client version, forcing full reload to next route.', route.fullPath)
  }
}
